var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"warning","title":_vm.tip}},[_vm._v(" "+_vm._s(_vm.$t('ledger_close_late'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }